<div class="modal-body">
    <h4 class="fw-bold" translate="jfse.install.title"></h4>
    <p translate="jfse.install.select-platform"></p>
    <div class="d-flex flex-row align-content-start justify-content-evenly">
        <div class="platform-icon">
            <app-windows (click)="downloadWindows()"></app-windows>
        </div>
        <div class="platform-icon">
            <app-apple (click)="downloadApple()"></app-apple>
        </div>
    </div>
    <div class="alert alert-warning alert-margin margin-top-16" role="alert">
        {{ translateService.instant('jfse.install.restart') }}
    </div>
    <div class="alert alert-info alert-margin" role="alert">
        {{ translateService.instant('jfse.install.panel-url') }}
        <div class="alert alert-dark alert-clickable" role="alert" (click)="openDaemonConfigPanel()">
            {{ environment.jfse.daemonConfigPanelUrl }}
        </div>
        {{ translateService.instant('jfse.install.host') }}
        <div class="alert alert-dark alert-clickable" role="alert" (click)="copyToClipBoard(environment.jfse.hostToConfig)">
            {{ environment.jfse.hostToConfig }}
        </div>
        {{ translateService.instant('jfse.install.port') }}
        <div class="alert alert-dark alert-clickable" role="alert" (click)="copyToClipBoard(environment.jfse.portToConfig)">
            {{ environment.jfse.portToConfig }}
        </div>
        {{ translateService.instant('jfse.install.disable-auto') }}
        <div class="alert alert-dark" role="alert" (click)="copyToClipBoard(environment.jfse.portToConfig)" translate="jfse.install.ip-auto"></div>
    </div>
    <div class="alert alert-warning alert-margin margin-top-16" role="alert" [innerHTML]="translateService.instant('jfse.install.save')"></div>
    <div class="d-flex flex-column flex-md-row-reverse btn-submit p-2">
        <button (click)="close()" class="btn btn-default btn-next mt-2 loading-btn fw-bold small text-uppercase" translate="jfse.install.close"></button>
    </div>
</div>
